/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;position:relative;height:100%}.selectedstudent[_ngcontent-%COMP%]{border-width:2px;border-style:solid}.padtop[_ngcontent-%COMP%]{margin-top:15px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/studentselect/studentselect.component.css.shim.ngstyle.js.pre-build-optimizer.js